import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/resource`;

export const resourceService = {
    createResourceFile: async function () {
        return axios.post(`${GATEWAY_URL}/create-resource-file`)
        .then((response) => {
            return response.data;
        });
    },
    getResource: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-resource`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    },
    getResourceTranslate: async function (resourceId: any) {
        return axios.get(`${GATEWAY_URL}/get-resource-translate`, {
            params: { resourceId }
        })
        .then((response) => {
            return response.data;
        });
    },
    getResources: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/list-resources`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    createResource: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-resource`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateResource: async function (key:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-resource`, params)
        .then((response) => {
            return response.data;
        });
    },
    deleteResource: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete-resource`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    }
}
